import Vue from 'vue'

Vue.mixin({
  methods: {
    getTitle(str) {
      return str.charAt(0).toUpperCase + str.charAt(1)
    }
  }
})



// WEBPACK FOOTER //
// ./src/mixins/capsMixins.js